export default function removeUndefined (obj) {
  for (const prop in obj) {
    if (obj[prop] === undefined) {
      delete obj[prop]
    }
  }
  return obj
}
